import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  CommissionLiteModel,
  CommissionModel,
  getCommissionInput,
  getCommissionsInput,
} from './model';

const ENDPOINT = 'commission-masters';

export function getCommissionsKey(input?: getCommissionsInput) {
  return ['get-commissions', input?.params];
}

export function getCommissionKey(input: getCommissionInput) {
  return ['get-commissions', input?.id];
}

export function useGetCommissions(
  input?: getCommissionsInput,
  options?: UseQueryOptions<ExtendedApiResult<CommissionLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<CommissionLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? getCommissionsKey(input),
      () =>
        QueryFetchFunction({
          url: `${ENDPOINT}`,
          params: input?.params,
        }),
      options,
    ),
    CommissionLiteModel,
  );
}

export function useGetCommission(
  input: getCommissionInput,
  options?: UseQueryOptions<ApiResult<CommissionModel>, ApiError>,
): UseQueryResult<ApiResult<CommissionModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? getCommissionKey(input),
      () =>
        QueryFetchFunction({
          url: `${ENDPOINT}/${input.id}`,
        }),
      options,
    ),
    CommissionModel,
  );
}
